export const ROUTE = {
  DASHBOARD: {
    PATH: '/dashboard',
    TITLE: 'dashboard',
  },
  SETTING: {
    PATH: '/settings',
    TITLE: 'setting',
  },
  GUEST: {
    LIST: {
      PATH: '/guests',
      TITLE: 'guest',
    },
    DETAIL: {
      PATH: '/guests/:id/detail',
      TITLE: 'guestDetail',
    },
  },
}
